<template>
    <prime-button
        class="selectable-list-item"
        :class="{ selected: props.selected }"
        :disabled="props.disabled"
        @click="emit('click')"
    >
        <span class="selectable-list-item-content">
            <slot name="leading" />
            <span class="selectable-list-item-label"><slot /></span>
        </span>
        <span v-if="$slots.actions" class="selectable-list-item-actions">
            <slot name="actions" />
        </span>
    </prime-button>
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button';

const props = withDefaults(defineProps<{
    selected?: boolean;
    disabled?: boolean;
}>(), {
    selected: false,
    disabled: false,
});

const emit = defineEmits<{ click: [] }>();
</script>

<style scoped lang="scss">
.selectable-list-item {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: var(--neutral200);
    border: solid 1px var(--neutral300);
    color: var(--primaryFont);
    font-weight: var(--boldFontWeight);
    padding: var(--defaultSpacing);
    text-align: left;

    &:hover {
        border-color: var(--neutral400);
        background-color: var(--neutral300);
    }

    &.selected {
        border-color: var(--accentColour);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

.selectable-list-item-content,
.selectable-list-item-actions {
    display: flex;
    align-items: center;
    gap: var(--defaultSpacing);
}

.selectable-list-item-actions {
    flex-shrink: 0;
}
</style>
